import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type {
    PaymentSummary,
    PaymentRankings,
    PaymentTrendPoint,
    PaymentTownRow,
} from '@shared/types/payment';

export function usePaymentMonths() {
    return useQuery({
        queryKey: ['payment', 'months'],
        queryFn: async () => (await api.get<string[]>('/payments/months')).data,
    });
}

export function usePaymentSummary(ym?: string) {
    return useQuery({
        queryKey: ['payment', 'summary', ym],
        queryFn: async () =>
            (await api.get<PaymentSummary>('/payments/summary', { params: { ym } })).data,
    });
}

export function usePaymentRankings(ym?: string) {
    return useQuery({
        queryKey: ['payment', 'rankings', ym],
        queryFn: async () =>
            (await api.get<PaymentRankings>('/payments/rankings', { params: { ym } })).data,
    });
}

export function usePaymentTrend(months = 12, townId?: number) {
    return useQuery({
        queryKey: ['payment', 'trend', months, townId],
        queryFn: async () =>
            (await api.get<PaymentTrendPoint[]>('/payments/trend', { params: { months, townId } })).data,
    });
}

export function usePaymentTowns(ym?: string, search?: string) {
    return useQuery({
        queryKey: ['payment', 'towns', ym, search],
        queryFn: async () =>
            (await api.get<PaymentTownRow[]>('/payments/towns', { params: { ym, search } })).data,
    });
}
